import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PaginationModule } from '@app/core/components/pagination/pagination.module';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';

import { FormFieldModule } from '@app/shared';

import { SearchInputComponent } from '@shared/form-controls/search-input/search-input.component';
import { IconComponent } from '@shared/icon/icon.component';
import { SpinnersModule } from 'lingo2-forms';
import { ClipboardModule } from 'ngx-clipboard';
import { OnUiButtonModule, OnUiInputModule } from 'onclass-ui';
import { ClassroomUserCardModule } from '../classroom-user-card';
import { InviteFooterComponent } from './invite-footer/invite-footer.component';
import { InviteHeaderComponent } from './invite-header/invite-header.component';
import { InviteStubComponent } from './invite-stub/invite-stub.component';
import { InviteToClassroomComponent } from './invite-to-classroom.component';
import { InviteUserCardComponent } from './invite-user-card/invite-user-card.component';

@NgModule({
  imports: [
    LocaleSharedModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    ClipboardModule,
    IconComponent,
    OnUiInputModule,
    FormFieldModule,
    SpinnersModule,
    PaginationModule,
    ClassroomUserCardModule,
    OnUiButtonModule,
    SearchInputComponent,
  ],
  declarations: [
    InviteToClassroomComponent,
    InviteHeaderComponent,
    InviteFooterComponent,
    InviteFooterComponent,
    InviteUserCardComponent,
    InviteStubComponent,
  ],
  exports: [InviteToClassroomComponent],
})
export class InviteToClassroomModule {}
